var _rect, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultAudioThumbnail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#1a365d",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#142c5c",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 12,
    fill: "url(#bgGradient)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "white",
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 65,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 58,
    r: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 30,
    width: 4,
    height: 35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 23,
    width: 4,
    height: 35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 27,
    width: 34,
    height: 5,
    rx: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "white",
    strokeWidth: 2,
    fill: "none",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78 45 Q85 50 78 55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82 40 Q92 50 82 60"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAudioThumbnail);
export default __webpack_public_path__ + "static/media/default-audio-thumbnail.1c7274447d5db43870b238b1ec3fc953.svg";
export { ForwardRef as ReactComponent };